// ════════════════════════════════════════════════════════════════════
// src/storeVisits/storeStaffData.js
//
// Shared, cached loaders for the store + duty-manager dropdowns in the
// SVR forms. Both /api/stores and /api/staff are unauthenticated reads
// (no requireAdmin), so a plain fetch works for any user.
//
//   stores  → store.name is the EXACT value store_visits.store FK-references
//             (stores.name). Using these values prevents the 23503 FK error.
//   staff   → filtered by .store === selected store name for duty manager.
//
// Module-level cache: fetched once per page load, reused across both forms
// and repeated opens.
// ════════════════════════════════════════════════════════════════════

let _storesCache = null;
let _staffCache = null;

function workerUrl() {
  if (typeof DB !== 'undefined' && typeof DB.workerUrl === 'function') return DB.workerUrl();
  return '';
}

function esc(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;')
    .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

export async function loadStores() {
  if (_storesCache) return _storesCache;
  const res = await fetch(workerUrl() + '/api/stores', { cache: 'no-store' });
  if (!res.ok) throw new Error('stores load failed: ' + res.status);
  _storesCache = await res.json();
  return _storesCache;
}

export async function loadStaff() {
  if (_staffCache) return _staffCache;
  const res = await fetch(workerUrl() + '/api/staff', { cache: 'no-store' });
  if (!res.ok) throw new Error('staff load failed: ' + res.status);
  _staffCache = await res.json();
  return _staffCache;
}

// Build <option> list for the store dropdown.
export function storeOptions(stores, selected) {
  if (!Array.isArray(stores)) return '<option>Loading stores…</option>';
  const head = '<option value="">— Select store —</option>';
  return head + stores.map(function (s) {
    const name = s && s.name != null ? s.name : '';
    const sel = name === selected ? ' selected' : '';
    return '<option value="' + esc(name) + '"' + sel + '>' + esc(name) + '</option>';
  }).join('');
}

// Build <option> list for the duty-manager dropdown (staff at `store`).
export function dutyOptions(staff, store, selected) {
  if (!store) return '<option value="">Select a store first</option>';
  if (!Array.isArray(staff)) return '<option>Loading staff…</option>';
  const atStore = staff.filter(function (p) { return p && p.store === store; });
  const head = '<option value="">— Select duty manager —</option>';
  if (atStore.length === 0) {
    return head + '<option value="" disabled>No staff found for this store</option>';
  }
  return head + atStore.map(function (p) {
    const name = p.name != null ? p.name : '';
    const sel = name === selected ? ' selected' : '';
    return '<option value="' + esc(name) + '"' + sel + '>' + esc(name) + '</option>';
  }).join('');
}
